import ethIcon from '../../../../common/images/staking/icon-eth.png';
import { ReactComponent as StarsIcon } from '../../../../common/svg/sidebar/header/icon-stars-small.svg';
import { getNetworkCurrencySymbol } from '../../../../lib/smart-contract-utils';
import styles from './WalletETHBalanceCard.module.css';

interface WalletProps {
  walletBalance: string;
  transparent?: boolean;
  isStars?: boolean;
}

export const WalletETHBalanceCard = ({
  walletBalance,
  transparent = false,
  isStars,
}: WalletProps) => {
  return (
    <div
      className={
        (transparent ? 'bg-transparent ' : `${styles.walletContainerBg} `) +
        styles.walletContainer
      }
    >
      <div className={styles.walletInfoContainer}>
        <div className={styles.starsImageContainer}>
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          {!(isStars ?? false) ? <img src={ethIcon} /> : <StarsIcon />}
        </div>
        <div className={styles.walletDiv}>
          <div className={styles.walletHeader}>WALLET BALANCE</div>
          {!(isStars ?? false) ? (
            <div
              className={styles.walletBody}
            >{`${walletBalance.toLocaleString()} ${getNetworkCurrencySymbol()} AVAILABLE`}</div>
          ) : (
            <div
              className={styles.walletBody}
            >{`${walletBalance.toLocaleString()} MOGUL AVAILABLE`}</div>
          )}
        </div>
      </div>
    </div>
  );
};
